import React from 'react';

import AssetRopaReviewPage from './AssetRopaReviewPage';

const ProcessingActivitiesAssetReviewsPage: React.FC = () => <AssetRopaReviewPage variant='admin' />;

export default ProcessingActivitiesAssetReviewsPage;
